import React from 'react';
import { LicensePlan } from '@/types/license';
import { groupFeatures } from '@/utils/featureUtils';
import { MatrixHeader } from './MatrixHeader';
import { MatrixBody } from './MatrixBody';

interface LicenseMatrixProps {
  plans: LicensePlan[];
}

export const LicenseMatrix: React.FC<LicenseMatrixProps> = ({ plans }) => {
  const allFeatures = plans[0]?.features || [];
  const featureGroups = groupFeatures(allFeatures);

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <MatrixHeader plans={plans} />
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <MatrixBody 
            featureGroups={featureGroups} 
            plans={plans} 
          />
        </tbody>
      </table>
    </div>
  );
};